package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import com.arena_web.ui.theme.AppTypography
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color

// Ghost-completion suggestion text (Figma 7694:307353): the substring matching
// the typed query renders in primary blue, the surrounding text in muted grey.
// Shared by every autocomplete dropdown — profile City/Languages, the address
// fields in CreateEventPopup / CreateClubContent / Settings club editor.
// Extracted from PersonalInfoEditModal's private MatchedText.

val SuggestionPrimary: CSSColorValue = Color("var(--arena-text-2)")
val SuggestionMuted: CSSColorValue = Color("rgba(153, 177, 191, 0.5)")

@Composable
fun MatchedText(
    text: String,
    query: String,
    fontSize: Int = 14,
    lineHeight: Int = 22,
) {
    val idx = if (query.isEmpty()) -1 else text.lowercase().indexOf(query.lowercase())
    val typedLen = query.length

    @Composable
    fun part(s: String, color: CSSColorValue) {
        SpanText(
            s,
            modifier = Modifier
                .sFontSize(fontSize)
                .fontWeight(AppTypography.Regular)
                .sLineHeight(lineHeight)
                .sLetterSpacing(0.028)
                .color(color)
        )
    }

    Row(verticalAlignment = Alignment.CenterVertically) {
        when {
            idx < 0 -> part(text, SuggestionMuted)
            idx == 0 -> {
                part(text.substring(0, typedLen), SuggestionPrimary)
                part(text.substring(typedLen), SuggestionMuted)
            }
            else -> {
                part(text.substring(0, idx), SuggestionMuted)
                part(text.substring(idx, idx + typedLen), SuggestionPrimary)
                part(text.substring(idx + typedLen), SuggestionMuted)
            }
        }
    }
}
